







import _ from 'lodash'
import BreadCrumbData from '@/modules/common/components/breadcrumb/breadcrumbData'
import Component from 'vue-class-component'
import IncomeStockMovement from '@/modules/stock/movement/domain/incomeStockMovement'
import incomeStockMovementForm from '@/modules/stock/movement/components/incomeStockMovementForm.vue'
import page from '../../../common/components/page.vue'
import { Prop } from 'vue-property-decorator'
import Vue from 'vue'
import Loading from '@/modules/common/components/loading.vue'

@Component({
  components: { Loading, incomeStockMovementForm, page }
})
export default class IncomeStockMovementEditPage extends Vue {
  breadCrumbData: BreadCrumbData | null = null

  movement?: IncomeStockMovement | null = null

  @Prop({ type: String, required: true }) movementId!: string

  async created () {
    this.movement = _.cloneDeep(await this.$store.dispatch('incomeStockMovement/select', Number(this.movementId)))

    this.breadCrumbData = new BreadCrumbData([{ textKey: 'stocks.label' },
      { textKey: 'stock-movements.label.2', routeName: 'stockMovements' },
      { text: this.movement!.formattedNumber! }])
  }
}
